﻿import { Deliverable, Fulfillment, Success } from 'types';
import { ApiBase } from 'classes/ApiBase';

export class Api extends ApiBase {

    protected static baseUrl = '/Api/Fulfillments';

    public static GetFulfillments(userId = 0, searchTerm: string): Promise<Fulfillment[]> {

        return this.Post('GetFulfillments', { searchTerm, userId })
            .then(res => res.json());

    }

    public static GetFulfillmentDeliverables(externalId: number, userId: number): Promise<Deliverable[]> {

        return this.Post(`GetFulfillmentDeliverables`, { externalId, userId })
            .then(res => res.json());

    }

    public static AddDeliverablesToFulfillment(externalId: number, userId: number, internalIds: number[]): Promise<Success<number[]>> {

        return this.Post('AddDeliverablesToFulfillment', { externalId, internalIds, userId })
            .then(res => res.json());

    }

    public static RemoveDeliverablesFromFulfillment(externalId: number, userId: number, internalIds: number[]): Promise<Success<number[]>> {

        return this.Post('RemoveDeliverablesFromFulfillment', { externalId, internalIds, userId })
            .then(res => res.json());

    }

    public static AddFulfillment(code: string, typeId: number, description: string, userId: number): Promise<Success<number>> {

        return this.Post('AddFulfillment', { code, description, typeId, userId })
            .then(res => res.json());

    }

    public static UpdateFulfillment(externalId: number, code: string, typeId: number, description: string, userId: number): Promise<Success<number>> {

        return this.Post('UpdateFulfillment', { code, description, externalId, typeId, userId })
            .then(res => res.json());

    }

    public static GetDeliverablesByFulfillmentDeliverableTypeId(deliverableTypeId: number, searchValue: string, userId: number): Promise<Deliverable[]> {

        return this.Post('GetDeliverablesByFulfillmentDeliverableTypeId', { deliverableTypeId, searchValue, userId })
            .then(res => res.json());

    }

}
